import React, { useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  CharacterSheetInterface,
  SKILLS,
} from "@dndModels";

import CharacterSkillInput from "@dndComponents/character/skills/CharacterSkillInput";
import CharacterSkillsButton from "@dndComponents/character/skills/CharacterSkillsButton";

interface Props {
  char: CharacterSheetInterface;
  shared: boolean;
}

export default function CharacterSkills({ 
  char,
  shared,
}: Props) {
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
  
  return (
    <Grid className="curved_border bg_black_transp">
      <div className="centered">
        <Grid container spacing={0} direction="row" 
          style={{
            width: "95%"
          }}>
          <Grid
            size={{
              xs: 12
            }}>
            <CharacterSkillsButton
              char={char}
              disabled={shared}
            />
          </Grid>
          { SKILLS.sort((a,b) => { return a.name.localeCompare(b.name); }).map(skill => {
            return (
              <Grid
                key={skill._id}
                size={{
                  xs: 12
                }}>
                <CharacterSkillInput
                  char={char}
                  skill={skill}
                />
              </Grid>
            );
          })}
        </Grid>
      </div>
    </Grid>
  );
}
